export default __webpack_public_path__ + "5e4f2771ccc8d2fe3d3d7d669890eab3.jpg";